window.atl_soy = window.atl_soy || {};

atl_soy.concat = function(a, b) {
    // handle arrays
    if (a.concat) {
        return a.concat(b);
    }

    //handle object
    var ret = {};
    for (var key in a) if (a.hasOwnProperty(key)) ret[key] = a[key];
    for (var key in b) if (b.hasOwnProperty(key)) ret[key] = b[key];
    return ret;
};

/*** EXPORTS FROM expose-exports-loader ***/
global["atl_soy"] = (atl_soy);
module.exports = (atl_soy);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlassian/soy-template-plugin-js/src/js/atlassian-deps.js
// module id = 2
// module chunks = 0